import { useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Select from 'react-select'
import { checkboxData } from './checkboxData';
import './style.css'
import { useUserAuth } from '../../context/UserAuthContext';
import { useFormik } from 'formik';
import { jewelleryTtkSchema } from '../schemas';
import axios from "axios";
import ThinksToKnowStatus from './ThinksToKnowStatus';

const JewelleryTTK = () => {
    const [ttkEditMode, setTtkEditMode] = useState(false)
    const { user, language, token, currency } = useUserAuth();
    const merchant_id = user.uid;
    const [merchant, setMerchant] = useState({});
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const getSingleDocumentHandler = async () => {
        try {
            const res = await axios.get(
                `${base_url}/api/v1/thinkstoknow/${merchant_id}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
            );
            const data = res.data.data;
            const details = data[0].details;
            if (details) {
                setMerchant(details);
            }
        } catch (error) {
            console.log(`Error : ${error}`);
        }
    };
    useEffect(() => {
        if (!merchant_id) return
        getSingleDocumentHandler()
    }, [merchant_id, token])

    const workingSinceOption = checkboxData.workSinceOption;
    const areaOfWorkingOption = checkboxData.areaOfWorking;
    const jewelleryTypeOption = checkboxData.jewelleryType;
    const categoriesServeOption = checkboxData.categoriesServe;
    const storeTypeOption = checkboxData.storeType;
    const formik = useFormik({
        initialValues: {
            workingSince: merchant.workingSince || [],
            areaOfWorking: merchant?.areaOfWorking || [],
            jewelleryType: merchant?.jewelleryType || [],
            categoriesServe: merchant?.categoriesServe || [],
            storeType: merchant?.storeType || [],
            rentalJewellery: merchant?.rentalJewellery || "",
            customization: merchant?.customization || "",
        },
        enableReinitialize: true,
        validationSchema: jewelleryTtkSchema,
        onSubmit: async (values) => {
            try {
                const data = {
                    id: merchant_id,
                    details: { ...values },
                };

                const res = await axios.post(`${base_url}/api/v1/thinkstoknow`, data, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });

                if (res.status === 201) {
                    toast.success("Things to know added successfully.");
                    setMerchant(values);
                    formik.setValues(values);
                    setTtkEditMode(false);
                } else if (res.status === 202) {
                    toast.success("Your update is pending approval by the admin.");
                    setTtkEditMode(false);
                } else {
                    toast.info(res.data.message || "Request submitted.");
                    setTtkEditMode(false);
                }

            } catch (error) {
                console.error(`Error ${error}`);
                toast.error('An error occurred while submitting the data.');
            }
        },
    });
    return (
        <div className="page-wrapper">
            <div className="container-fluid">
                <ThinksToKnowStatus />
                <div className='row'>
                    <div className='col-md-12'>
                        <div className='card'>
                            <div className='card-header bg-primary text-white'>
                                <h5> {language === 'en' ? 'Things to Know' : 'जानने योग्य जानकारी भरे'}</h5>
                            </div>
                            <div className='card-body'>
                                {
                                    merchant && (
                                        <>
                                            <div className='table-responsive'>
                                                <table className='table text-center' cellPadding={0} cellSpacing={0} style={{ border: '1px solid #fff ' }}>
                                                    <tbody className='ttk_preview'>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th style={{ width: '25%' }}>Working Since</th>
                                                            <th style={{ width: '25%' }}>Area Of Working</th>
                                                            <th style={{ width: '25%' }}>Jewellery Type</th>
                                                            <th style={{ width: '25%' }}>Categories We Serve</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.workingSince?.map((item, index) => {
                                                                    return <span key={index}>{item.value}</span>
                                                                })
                                                            }</td>

                                                            <td>{
                                                                merchant?.areaOfWorking
                                                                    ?.map((item, index) => {
                                                                        return <>
                                                                            <i className='fa fa-check text-success' />
                                                                            <span key={index}>{item.value} </span>
                                                                        </>
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant?.jewelleryType
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td>{
                                                                merchant.categoriesServe
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>
                                                        </tr>
                                                        <tr style={{ color: '#41B0FA' }}>
                                                            <th>Store Type</th>
                                                            <th>Rental Jewellery</th>
                                                            <th>Customization</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{
                                                                merchant.storeType
                                                                    ?.map((item, index) => {
                                                                        return (
                                                                            <>
                                                                                <i className='fa fa-check text-success' />
                                                                                <span key={index}>{item.value} </span>
                                                                            </>
                                                                        )
                                                                    })
                                                            }</td>
                                                            <td>{merchant?.rentalJewellery}</td>
                                                            <td>{merchant?.customization}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </>
                                    )
                                }
                                <center >
                                    <button className='btn btn-primary mb-2' onClick={() => setTtkEditMode(!ttkEditMode)}>{`${merchant ? 'Make Changes' : 'Tell me more about yourself'}`}</button>
                                </center>
                                {
                                    ttkEditMode && (
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className='row'>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Working Since <span className='text-danger'>*</span></label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={workingSinceOption}
                                                            selected
                                                            value={formik.values.workingSince}
                                                            onChange={(workingSince) => formik.setFieldValue('workingSince', workingSince)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.workingSince && formik.errors.workingSince ? (
                                                            <div className="text-danger">{formik.errors.workingSince}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Serving Cities</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={areaOfWorkingOption}
                                                            selected
                                                            value={formik.values.areaOfWorking}
                                                            onChange={(areaOfWorking) => formik.setFieldValue('areaOfWorking', areaOfWorking)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.areaOfWorking && formik.errors.areaOfWorking ? (
                                                            <div className="text-danger">{formik.errors.areaOfWorking}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Jewellery Type</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={jewelleryTypeOption}
                                                            selected
                                                            value={formik.values.jewelleryType}
                                                            onChange={(jewelleryType) => formik.setFieldValue('jewelleryType', jewelleryType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.jewelleryType && formik.errors.jewelleryType ? (
                                                            <div className="text-danger">{formik.errors.jewelleryType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Categories We Serve</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={categoriesServeOption}
                                                            selected
                                                            value={formik.values.categoriesServe}
                                                            onChange={(categoriesServe) => formik.setFieldValue('categoriesServe', categoriesServe)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.categoriesServe && formik.errors.categoriesServe ? (
                                                            <div className="text-danger">{formik.errors.categoriesServe}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className='col-md-6'>
                                                    <div className='form-group'>
                                                        <label>Store Type</label>
                                                        <Select
                                                            closeMenuOnSelect={false}
                                                            isMulti
                                                            options={storeTypeOption}
                                                            selected
                                                            value={formik.values.storeType}
                                                            onChange={(storeType) => formik.setFieldValue('storeType', storeType)}
                                                            onBlur={formik.handleBlur}
                                                        />
                                                        {formik.touched.storeType && formik.errors.storeType ? (
                                                            <div className="text-danger">{formik.errors.storeType}</div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>
                                                            Rental jewellery <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="rentalJewellery"
                                                            className="form-select"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.rentalJewellery}
                                                        >
                                                            <option value="" disabled hidden>
                                                                Select Option
                                                            </option>
                                                            <option value="available">Available</option>
                                                            <option value="not available">Not Available</option>
                                                        </select>

                                                        {formik.touched.rentalJewellery &&
                                                            formik.errors.rentalJewellery ? (
                                                            <div className="text-danger">
                                                                {formik.errors.rentalJewellery}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="form-group">
                                                        <label>
                                                            Customization <span className="text-danger">*</span>
                                                        </label>
                                                        <select
                                                            name="customization"
                                                            className="form-select"
                                                            onChange={formik.handleChange}
                                                            onBlur={formik.handleBlur}
                                                            value={formik.values.customization}
                                                        >
                                                            <option value="" disabled hidden>
                                                                Select Option
                                                            </option>
                                                            <option value="available">Available</option>
                                                            <option value="not available">Not Available</option>
                                                        </select>

                                                        {formik.touched.customization &&
                                                            formik.errors.customization ? (
                                                            <div className="text-danger">
                                                                {formik.errors.customization}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='form-group'>
                                                <button className='btn btn-primary' type='submit'>Submit</button>
                                            </div>
                                        </form>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default JewelleryTTK